
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-dashboard",
  components: {},
})
export class IconDashboard extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconDashboard;
